import Chip from 'components/@extended/Chip.tsx';
import { LockOutlined as LockOutlinedIcon } from 'components/icons';
import { ConfidentialChip } from 'components/matters/MatterIndicators';
import { useIsNewDesign } from 'components/tables/list-table/filter-bar/useIsNewDesign';

/**
 * An experience record's confidential flag beside its name or value: the padlock chip, or in the new
 * design the labelled confidential chip, `label` naming what is confidential.
 */
export const XrConfidentialMarker = ({ label }: { label: string }) =>
    useIsNewDesign() ? (
        <ConfidentialChip label={label} />
    ) : (
        <Chip size="small" label={<LockOutlinedIcon />} type={'experienceRecord'} />
    );
